import { GameStates } from '../../classes/gameStates/gameStates.class'

/** 
 * @file Defines the {@link GAME_STATES} constant 
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

/**
 * Game states.
 * @type {GameStates}
 * @constant
 * @default
 */
export const GAME_STATES = new GameStates()